<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Rabaty</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Rabaty</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox-title" @click="isValueOpen = !isValueOpen">
          <h5>Wartość</h5>
          <span :class="chevronValueClass" class="ibox-toggle"></span>
        </div>
        <div class="ibox-content" v-show="isValueOpen">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group flex">
                    <label for="file" class="col-sm-3 control-label">
                      Plik rabatów asystenta cen
                    </label>
                    <div class="col-sm-6">
                      <div class="fileinput fileinput-new input-group">
                        <span
                          for="file"
                          class="input-group-addon btn btn-default btn-file"
                        >
                          <input
                            type="file"
                            name="file"
                            id="file"
                            @change="changeFile"
                            multiple="multiple"
                          />
                        </span>
                      </div>
                      <div class="has-error">
                        <span
                          v-for="(error, index) in importErrors"
                          :key="index"
                          class="help-block"
                        >
                          {{ error }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="canAddDiscount" class="col-lg-4">
                  <button
                    @click="importFile"
                    class="btn btn-primary"
                    :disabled="!discountFile || uploading"
                  >
                    <span v-if="!uploading">Importuj</span>
                    <span v-else class="fa fa-spinner fa-spin"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="checkedNodes.length > 1">
            <hr />
            <dl class="dl-horizontal">
              <dt>Zaznaczone obiekty:</dt>
              <dd>{{ checkedNodes.length }}</dd>
              <dt>Wartość:</dt>
              <dd>
                <input
                  v-model="checkedNodesValue"
                  @input="clearDiscountErrors"
                  type="number"
                  class="form-control"
                />
                <span
                  v-for="(error, index) in discountErrors.value"
                  :key="index"
                  class="help-block"
                >
                  {{ error }}
                </span>
                <span
                  v-for="(error, index) in discountErrors.non_field_errors"
                  :key="'nf' + index"
                  class="help-block"
                >
                  {{ error }}
                </span>
              </dd>
            </dl>
            <button
              v-if="canChangeDiscount"
              @click="updateCheckedDiscounts"
              :disabled="saving"
              class="btn btn-primary pull-right"
            >
              Zapisz
            </button>
          </div>
          <div
            v-else-if="selectedNode && !selectedNode.is_global"
            class="selected-discount"
          >
            <hr />
            <dl class="dl-horizontal">
              <dt>Wybrany rabat:</dt>
              <dd>
                <discount-node-label :node="selectedNode" />
              </dd>
              <dt>Wartość:</dt>
              <dd>
                <input
                  v-model="selectedNode.value"
                  @input="clearDiscountErrors"
                  type="number"
                  class="form-control"
                />
                <span
                  v-for="(error, index) in discountErrors.value"
                  :key="index"
                  class="help-block"
                >
                  {{ error }}
                </span>
                <span
                  v-for="(error, index) in discountErrors.non_field_errors"
                  :key="'nf' + index"
                  class="help-block"
                >
                  {{ error }}
                </span>
              </dd>
            </dl>

            <dl v-if="selectedNode.is_can_edit_secondary" class="dl-horizontal">
              <dt>Wartość dodatkowa:</dt>
              <dd>
                <input
                  v-model="selectedNode.secondary_value"
                  @input="clearDiscountErrors"
                  type="number"
                  class="form-control"
                />
                <span
                  v-for="(error, index) in discountErrors.secondary_value"
                  :key="index"
                  class="help-block"
                >
                  {{ error }}
                </span>
              </dd>
            </dl>
            <button
              v-if="canChangeDiscount"
              @click="updateDiscount"
              :disabled="saving"
              class="btn btn-primary pull-right"
            >
              Zapisz
            </button>
          </div>
        </div>
      </div>
      <div v-if="canViewNotes" class="col-lg-12">
        <discount-notes
          :discount="selectedNode || null"
          @change="(notes) => (selectedNode.notes = notes)"
        />
      </div>
      <div class="col-lg-12">
        <div class="ibox-title" @click="isTransferOpen = !isTransferOpen">
          <h5>Eksport i import drzewa rabatów</h5>
          <span :class="chevronTransferClass" class="ibox-toggle"></span>
        </div>
        <div class="ibox-content" v-show="isTransferOpen">
          <discount-tree-transfer
            :scope-roots="checkedBranchRoots"
            :can-import="canChangeDiscount"
            @imported="reloadDiscounts"
          />
        </div>
      </div>
      <div class="col-lg-12">
        <div v-if="data" class="ibox float-e-margins">
          <div class="ibox-title" @click="isTreeOpen = !isTreeOpen">
            <h5>Drzewo rabatów</h5>
            <span :class="chevronTreeClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isTreeOpen">
            <div v-if="loading" class="loading-entity">
              <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <tree
              v-else
              :nodes="data.nodes"
              :config="data.config"
              @node-toggle="storeOpenedNodes"
            >
              <template #before-input="props">
                <i
                  :class="nodeIconClass(props.node)"
                  class="node-type-icon"
                ></i>
                <div :data-id="props.node.pk" @click="onNodeClick(props.node)">
                  <discount-node-label
                    :node="props.node"
                    :show-actions="true"
                    :can-add="canAddDiscount"
                    :can-delete="canDeleteDiscount"
                    @add-quantity="addQuantityDiscounts"
                    @edit-quantity="openQuantityModal"
                    @delete-quantity="deleteQuantityDiscounts"
                  />
                </div>
              </template>
            </tree>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal
    v-if="confirmAction"
    :title="
      confirmAction.kind === 'create'
        ? 'Dodanie rabatów dla nakładów'
        : 'Usunięcie rabatów dla nakładów'
    "
    :content="confirmContent"
    @callbackOk="runConfirmedAction"
    @callbackClose="closeConfirm"
  />

  <div v-if="saving" class="saving-overlay">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>

  <div v-if="mActions" class="modal-dialog abs">
    <div class="modal-content">
      <div class="inmodal">
        <div v-if="modalLoading" class="loading-entity">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <template v-else>
          <div class="modal-header">
            <h4 class="modal-title">
              Edycja rabatów dla nakładów:
              {{ modalTitle }}
            </h4>
          </div>
          <div class="modal-body">
            <div v-if="modalFromAssistant" class="alert alert-info">
              Wartości z asystenta cen zostaną zapisane dla nakładów produktu we
              wszystkich jego kategoriach. Niezerowa zmiana wyzeruje rabaty
              produktu i kategorii nad nakładem w każdej gałęzi, tak jak edycja
              pojedynczego rabatu.
            </div>
            <div class="form-horizontal discounts">
              <div class="row m-b-sm">
                <div class="col-lg-1">
                  <input @change="selectAll" v-model="sAll" type="checkbox" />
                </div>
                <div class="col-lg-11">
                  <div class="row m-b-sm">
                    <div class="col-lg-12">
                      <button
                        @click="changeCheckedValues(-0.1)"
                        type="button"
                        class="btn btn-success btn-one-down"
                        title="Na doł o 0.1%"
                      >
                        <span class="fa fa-angle-right"></span>
                      </button>
                      <button
                        @click="changeCheckedValues(0.1)"
                        type="button"
                        class="btn btn-success btn-one-up"
                        title="Do góry o 0.1%"
                      >
                        <span class="fa fa-angle-right"></span>
                      </button>
                      |
                      <button
                        @click="changeCheckedValues(-1)"
                        type="button"
                        class="btn btn-success btn-double-down"
                        title="Na doł o 1%"
                      >
                        <span class="fa fa-angle-double-right"></span>
                      </button>
                      <button
                        @click="changeCheckedValues(1)"
                        type="button"
                        class="btn btn-success btn-double-up"
                        title="Do góry o 1%"
                      >
                        <span class="fa fa-angle-double-right"> </span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-7">
                      <div class="form-group">
                        <label
                          for="value"
                          class="control-label col-sm-3 no-padd"
                        >
                          Wartość
                        </label>
                        <div class="col-sm-9">
                          <input
                            id="value"
                            type="text"
                            class="form-control"
                            placeholder="Wartość"
                            v-model="calcValue"
                            @input="calcValueErrors = []"
                          />
                          <div class="has-error">
                            <span
                              v-for="(error, index) in calcValueErrors"
                              :key="index"
                              class="help-block"
                            >
                              {{ error }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <button @click="applyCalcValue" class="btn btn-success">
                        Przelicz wybrane
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-lg-12">
                  <div class="ibox">
                    <div
                      v-for="(child, index) in modalChildren"
                      :key="child.id"
                      class="row"
                    >
                      <div class="col-lg-1">
                        <input
                          v-model="child.checked"
                          type="checkbox"
                          class="discounts select-row"
                        />
                      </div>
                      <div class="col-lg-11">
                        <div class="has-error">
                          <span
                            v-for="(error, errorIndex) in modalErrors[index]
                              ?.non_field_errors"
                            :key="errorIndex"
                            class="help-block"
                          >
                            {{ error }}
                          </span>
                        </div>
                        <div class="form-group">
                          <label for="value" class="control-label col-sm-2">
                            {{ child.title }}
                          </label>
                          <div class="col-sm-9">
                            <input
                              id="value"
                              name="value"
                              type="text"
                              v-model="child.value"
                              class="form-control"
                              :class="'discount-input-' + index"
                              :placeholder="child.title"
                            />
                            <div class="has-error">
                              <span
                                v-for="(error, errorIndex) in modalErrors[index]
                                  ?.value"
                                :key="errorIndex"
                                class="help-block"
                              >
                                {{ error }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="closeModal" class="btn btn-white">Anuluj</button>
            <button
              v-if="canAddDiscount"
              @click="saveDiscount"
              :disabled="saving"
              class="btn btn-primary"
            >
              Zapisz
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
  <div v-if="mActions" @click="closeModal" class="modal-backdrop"></div>
</template>

<script>
import { computed, ref, watch } from "vue";
import treeview from "vue3-treeview";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import {
  discountPermissionsConst,
  discountNotePermissionsConst,
} from "../../constants/productConstants";
import Modal from "../caffeprint/Modal.vue";
import DiscountNodeLabel from "./DiscountNodeLabel.vue";
import DiscountNotes from "./DiscountNotes.vue";
import DiscountTreeTransfer from "./DiscountTreeTransfer.vue";
import "vue3-treeview/dist/style.css";

// Keeps the expanded branches between reloads of the tree, the way the jstree
// state plugin did in the old admin panel.
const OPENED_NODES_KEY = "discountTreeOpenedNodes";

const LIST_ERROR = "Nie udało się pobrać listy rabatów.";
const UPDATE_SUCCESS = "Rabat został zaktualizowany.";
const UPDATE_MANY_SUCCESS = "Rabaty zostały zaktualizowane.";
const UPDATE_MANY_ERROR = "Błąd podczas aktualizacji rabatów.";
const GENERIC_ERROR = "Wystąpił nieoczekiwany błąd.";

// Flattens a DRF error response into a list of readable messages.
const collectErrors = (data) => {
  if (!data) {
    return [];
  }
  if (typeof data === "string") {
    return [data];
  }
  if (Array.isArray(data)) {
    return data.reduce((acc, item) => acc.concat(collectErrors(item)), []);
  }
  if (typeof data !== "object") {
    return [];
  }
  return Object.entries(data).reduce((acc, [key, value]) => {
    const messages = collectErrors(value);
    if (key === "non_field_errors" || key === "detail") {
      return acc.concat(messages);
    }
    return acc.concat(messages.map((message) => key + ": " + message));
  }, []);
};

// Errors of a single field, always as a list.
const fieldErrors = (data, field) => {
  if (!data || Array.isArray(data) || typeof data !== "object") {
    return [];
  }
  const value = data[field];
  if (!value) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};

// Errors that belong to the whole response instead of one of its fields.
const nonFieldErrors = (data) => {
  if (!data) {
    return [];
  }
  if (typeof data === "string") {
    return [data];
  }
  if (Array.isArray(data)) {
    return data.filter((item) => typeof item === "string");
  }
  return fieldErrors(data, "non_field_errors").concat(
    fieldErrors(data, "detail")
  );
};

// The toaster renders HTML, while plan messages carry names of products.
const escapeHtml = (text) =>
  String(text).replace(
    /[&<>"']/g,
    (char) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[char])
  );

// Messages of a plan of the bulk update (errors or skipped discounts).
const planMessages = (items) =>
  (Array.isArray(items) ? items : []).map((item) =>
    escapeHtml(
      (item.id ? "ID " + item.id + ": " : "") + (item.message || item.reason)
    )
  );

export default {
  name: "DiscountList",
  mixins: [],
  components: {
    tree: treeview,
    DiscountNodeLabel,
    DiscountNotes,
    DiscountTreeTransfer,
    Modal,
  },
  props: {},

  setup() {
    const store = useStore();
    // The quantity discount actions (create, bulk update, import) are POST
    // endpoints, so the backend checks the add permission for all of them.
    const canAddDiscount = computed(() =>
      hasPermission(discountPermissionsConst.add)
    );
    const canChangeDiscount = computed(() =>
      hasPermission(discountPermissionsConst.update)
    );
    const canDeleteDiscount = computed(() =>
      hasPermission(discountPermissionsConst.delete)
    );

    // Without it the tree endpoint sends no notes at all.
    const canViewNotes = computed(() =>
      hasPermission(discountNotePermissionsConst.view)
    );

    const discountsData = computed(() => store.getters.getDiscountsData);
    const discountData = computed(() => store.getters.getDiscountData);
    const updateDiscountsData = computed(
      () => store.getters.getUpdateDiscountsData
    );
    const createDiscountsForQData = computed(
      () => store.getters.getCreateDiscountsForQData
    );
    const importDiscountsForQData = computed(
      () => store.getters.getImportDiscountsForQData
    );
    const selectedNode = ref();
    const discountFile = ref();
    const mActions = ref(false);
    const modalLoading = ref(false);
    const modalTitle = ref("");
    // The price assistant saves the values under all categories of the
    // product, an edit opened from the tree only in the clicked branch.
    const modalFromAssistant = ref(false);
    const modalChildren = ref([]);
    const modalErrors = ref([]);
    const loading = ref(false);
    const saving = ref(false);
    const uploading = ref(false);
    const discountsLoaded = ref(false);
    const sAll = ref(false);
    const calcValue = ref(0);
    const calcValueErrors = ref([]);
    const checkedNodesValue = ref(0);
    const discountErrors = ref({
      value: [],
      secondary_value: [],
      non_field_errors: [],
    });
    const importErrors = ref([]);
    // Tells the watchers which request they are handling, so a stale result of
    // another action is never reported as the result of this one.
    const pendingUpdate = ref(null);
    const pendingQuantityAction = ref(null);
    const data = ref({
      config: {
        roots: [],
        checkboxes: true,
      },
      nodes: {},
    });
    const isValueOpen = ref(true);
    const isTransferOpen = ref(false);
    const isTreeOpen = ref(true);

    const chevronValueClass = computed(() =>
      isValueOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronTransferClass = computed(() =>
      isTransferOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronTreeClass = computed(() =>
      isTreeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const checkedNodes = computed(() =>
      Object.values(data.value.nodes).filter((node) => node.state.checked)
    );
    // Checked nodes that start a branch - a node inside another checked
    // branch is already covered by it.
    const checkedBranchRoots = computed(() =>
      checkedNodes.value.filter((node) => {
        let parent = data.value.nodes["id" + node.parentPk];
        while (parent) {
          if (parent.state.checked) {
            return false;
          }
          parent = data.value.nodes["id" + parent.parentPk];
        }
        return true;
      })
    );

    const nodeIconClass = (node) =>
      node.type === "product" ? "fa fa-lg fa-cube" : "fa fa-lg fa-folder";

    const showError = (responseData, fallback) => {
      const messages = collectErrors(responseData);
      store.dispatch("showToaster", {
        type: "error",
        content: messages.length ? messages.join("<br>") : fallback,
      });
    };

    const showSuccess = (content) => {
      store.dispatch("showToaster", { type: "success", content: content });
    };

    const clearDiscountErrors = () => {
      discountErrors.value = {
        value: [],
        secondary_value: [],
        non_field_errors: [],
      };
    };

    const readOpenedNodes = () => {
      try {
        const stored = JSON.parse(localStorage.getItem(OPENED_NODES_KEY));
        return Array.isArray(stored) ? stored : [];
      } catch (e) {
        return [];
      }
    };

    const storeOpenedNodes = () => {
      const opened = Object.keys(data.value.nodes).filter(
        (nodeId) => data.value.nodes[nodeId].state.opened
      );
      localStorage.setItem(OPENED_NODES_KEY, JSON.stringify(opened));
    };

    const clearCheckedNodes = () => {
      checkedNodes.value.forEach((node) => {
        node.state.checked = false;
      });
    };

    const closeModal = () => {
      mActions.value = false;
      modalLoading.value = false;
    };

    const openQuantityModal = (node) => {
      onNodeClick(node);
      modalFromAssistant.value = false;
      modalTitle.value = "";
      modalChildren.value = [];
      modalErrors.value = [];
      calcValue.value = 0;
      calcValueErrors.value = [];
      sAll.value = false;
      modalLoading.value = true;
      mActions.value = true;
      store.dispatch("getDiscount", { id: node.pk });
    };

    function onNodeClick(node) {
      selectedNode.value = node;
      clearDiscountErrors();
    }

    // Adding and deleting the quantity discounts are saved at once, so both
    // wait for a confirmation first.
    const confirmAction = ref(null);

    const confirmContent = computed(() => {
      const action = confirmAction.value;
      if (!action) {
        return "";
      }
      const name =
        "<b>ID: " +
        escapeHtml(action.node.object_id) +
        " | " +
        escapeHtml(action.node.title) +
        "</b>";
      if (action.kind === "create") {
        return (
          "Czy na pewno chcesz dodać rabaty dla nakładów produktu " +
          name +
          "?<br>Rabaty z wartością 0 zostaną utworzone dla wszystkich nakładów produktu. Rabaty pojawią się w każdej kategorii, w której jest produkt."
        );
      }
      return (
        "Czy na pewno chcesz usunąć rabaty dla nakładów produktu " +
        name +
        "?<br>Rabaty wszystkich nakładów tego produktu w tej kategorii zostaną usunięte razem z ich wartościami. Tej operacji nie można cofnąć."
      );
    });

    const closeConfirm = () => {
      confirmAction.value = null;
    };

    const addQuantityDiscounts = (node) => {
      onNodeClick(node);
      if (canAddDiscount.value) {
        confirmAction.value = { kind: "create", node };
      }
    };

    const deleteQuantityDiscounts = (node) => {
      onNodeClick(node);
      if (canDeleteDiscount.value) {
        confirmAction.value = { kind: "delete", node };
      }
    };

    const runConfirmedAction = () => {
      const action = confirmAction.value;
      closeConfirm();
      if (!action || saving.value) {
        return;
      }
      saving.value = true;
      pendingQuantityAction.value = action.kind;
      store.dispatch(
        action.kind === "create"
          ? "createDiscountForQuantitity"
          : "deleteDiscountForQuantitity",
        { id: action.node.pk }
      );
    };

    const buildTreeData = (items) => {
      const nodes = {};
      const childrenByParent = {};
      const previousNodes = data.value.nodes || {};
      const openedNodes = new Set(readOpenedNodes());

      items.forEach((element) => {
        const nodeId = "id" + element.id;
        const parentKey =
          element.parent === null ? "#" : "id" + String(element.parent);

        nodes[nodeId] = {
          ...element,
          // Read by the treeview for its own (hidden) label.
          text: element.title,
          pk: element.id,
          // The treeview overwrites `id` (and may overwrite `parent`) with its own
          // keys, so the ids of the API are kept under separate names.
          parentPk: element.parent,
          state: {
            opened: openedNodes.has(nodeId),
            // Reloading the tree after a save keeps the checked discounts.
            checked: previousNodes[nodeId]
              ? previousNodes[nodeId].state.checked === true
              : false,
          },
          children: [],
        };

        if (!childrenByParent[parentKey]) {
          childrenByParent[parentKey] = [];
        }
        childrenByParent[parentKey].push(nodeId);
      });

      Object.keys(nodes).forEach((nodeId) => {
        nodes[nodeId].children = childrenByParent[nodeId] || [];
      });
      const roots = childrenByParent["#"] || [];
      const hasOpenedNode = Object.keys(nodes).some(
        (nodeId) => nodes[nodeId].state.opened
      );
      if (!hasOpenedNode && roots.length && nodes[roots[0]]) {
        nodes[roots[0]].state.opened = true;
      }

      return {
        config: {
          roots,
          checkboxes: true,
        },
        nodes,
      };
    };

    const loadDiscounts = () => {
      if (loading.value) {
        return;
      }
      loading.value = true;
      store.dispatch("getDiscounts");
    };

    const reloadDiscounts = () => {
      discountsLoaded.value = false;
      if (isTreeOpen.value) {
        loadDiscounts();
      }
    };

    const updateDiscount = () => {
      if (!canChangeDiscount.value || !selectedNode.value) {
        return;
      }
      clearDiscountErrors();
      saving.value = true;
      pendingUpdate.value = "single";

      const payload = {
        pk: selectedNode.value.pk,
        value: selectedNode.value.value,
      };
      // Quantity and global discounts have no editable secondary value, so it
      // must not be sent back to the API.
      if (selectedNode.value.is_can_edit_secondary) {
        payload.secondary_value = selectedNode.value.secondary_value;
      }

      store.dispatch("updateDiscount", payload);
    };

    const updateCheckedDiscounts = () => {
      if (!canChangeDiscount.value || checkedNodes.value.length < 2) {
        return;
      }
      clearDiscountErrors();
      saving.value = true;
      pendingUpdate.value = "multiple";
      store.dispatch("updateDiscounts", {
        pks: checkedNodes.value.map((node) => node.pk),
        value: checkedNodesValue.value,
      });
    };

    const selectAll = () => {
      modalChildren.value.forEach((child) => {
        child.checked = sAll.value;
      });
    };

    const changeCheckedValues = (delta) => {
      modalChildren.value.forEach((child) => {
        if (!child.checked) {
          return;
        }
        const value = Number(child.value);
        if (child.value === "" || child.value === null || isNaN(value)) {
          return;
        }
        child.value = (value + Number(delta)).toFixed(2);
      });
    };

    const applyCalcValue = () => {
      calcValueErrors.value = [];
      const value = Number(calcValue.value);
      if (calcValue.value === "" || calcValue.value === null || isNaN(value)) {
        calcValueErrors.value = ["Wymagana poprawna liczba."];
        return;
      }
      changeCheckedValues(value);
    };

    const saveDiscount = () => {
      if (!canAddDiscount.value) {
        return;
      }
      modalErrors.value = modalChildren.value.map(() => ({}));
      saving.value = true;
      pendingQuantityAction.value = "update";
      store.dispatch("updateDiscountForQ", {
        items: modalChildren.value.map((child) => ({
          id: child.id,
          value: child.value,
        })),
        allCategories: modalFromAssistant.value,
      });
    };

    const changeFile = (file) => {
      discountFile.value = file.target.files[0];
      importErrors.value = [];
    };

    const importFile = () => {
      if (!canAddDiscount.value || !discountFile.value) {
        return;
      }
      importErrors.value = [];
      uploading.value = true;
      modalFromAssistant.value = true;
      store.dispatch("importDiscountForQ", {
        file: discountFile.value,
      });
    };

    watch(
      () => discountsData.value,
      function (newValue) {
        loading.value = false;
        if (newValue?.status !== 200 || !Array.isArray(newValue?.data)) {
          showError(newValue?.data, LIST_ERROR);
          return;
        }
        data.value = buildTreeData(newValue.data);
        storeOpenedNodes();
        // The tree is rebuilt from scratch, so the selection has to point at
        // the new node object to stay editable.
        if (selectedNode.value) {
          selectedNode.value =
            data.value.nodes["id" + selectedNode.value.pk] || null;
        }
        discountsLoaded.value = true;
      }
    );

    watch(
      () => isTreeOpen.value,
      function (newValue) {
        if (newValue && !discountsLoaded.value) {
          loadDiscounts();
        }
      },
      { immediate: true }
    );

    // Discount details feed the quantity modal - both when it is opened from
    // the tree and when the discounts come from an imported file.
    watch(
      () => discountData.value,
      function (newValue) {
        if (!newValue?.status) {
          return;
        }
        if (newValue.status !== 200) {
          closeModal();
          showError(newValue.data, GENERIC_ERROR);
          return;
        }
        modalTitle.value = newValue.data.title;
        modalChildren.value = (newValue.data.children || []).map((child) => ({
          id: child.id,
          title: child.title,
          value: child.value,
          checked: false,
        }));
        modalErrors.value = modalChildren.value.map(() => ({}));
        sAll.value = false;
        calcValue.value = 0;
        calcValueErrors.value = [];
        modalLoading.value = false;
        mActions.value = true;
      }
    );

    watch(
      () => updateDiscountsData.value,
      function (newValue) {
        const kind = pendingUpdate.value;
        if (!kind) {
          return;
        }
        pendingUpdate.value = null;
        saving.value = false;

        if (kind === "multiple") {
          checkedNodesValue.value = 0;
        }
        if (newValue?.status === 200) {
          if (kind === "multiple") {
            clearCheckedNodes();
            // The global discount and hidden ones are left as they are.
            const skipped = planMessages(newValue.data?.skipped);
            if (skipped.length) {
              store.dispatch("showToaster", {
                type: "warning",
                content: "Pominięte rabaty:<br>" + skipped.join("<br>"),
              });
            }
          }
          showSuccess(
            kind === "multiple" ? UPDATE_MANY_SUCCESS : UPDATE_SUCCESS
          );
          reloadDiscounts();
          return;
        }
        // The bulk update is planned as a whole and refused with the list of
        // discounts that would zero each other - nothing is saved then.
        const planErrors = planMessages(newValue?.data?.errors);
        discountErrors.value = {
          value: fieldErrors(newValue?.data, "value"),
          secondary_value: fieldErrors(newValue?.data, "secondary_value"),
          non_field_errors: planErrors.length
            ? []
            : nonFieldErrors(newValue?.data),
        };
        if (planErrors.length) {
          store.dispatch("showToaster", {
            type: "error",
            content: planErrors.join("<br>"),
          });
          return;
        }
        showError(newValue?.data, GENERIC_ERROR);
      }
    );

    watch(
      () => createDiscountsForQData.value,
      function (newValue) {
        const action = pendingQuantityAction.value;
        if (!action) {
          return;
        }
        pendingQuantityAction.value = null;
        saving.value = false;

        if (newValue?.status === 200 || newValue?.status === 201) {
          if (action === "update") {
            closeModal();
            showSuccess(UPDATE_MANY_SUCCESS);
          } else {
            showSuccess(UPDATE_SUCCESS);
          }
          reloadDiscounts();
          return;
        }
        if (action === "update") {
          modalErrors.value = modalChildren.value.map((child, index) =>
            Array.isArray(newValue?.data) ? newValue.data[index] || {} : {}
          );
          showError(
            Array.isArray(newValue?.data) ? null : newValue?.data,
            UPDATE_MANY_ERROR
          );
          return;
        }
        showError(newValue?.data, GENERIC_ERROR);
      }
    );

    watch(
      () => importDiscountsForQData.value,
      function (newValue) {
        uploading.value = false;
        if (newValue?.status === 200) {
          // The modal is opened by the discount details watcher.
          return;
        }
        importErrors.value = fieldErrors(newValue?.data, "file").concat(
          nonFieldErrors(newValue?.data)
        );
        showError(newValue?.data, GENERIC_ERROR);
      }
    );

    return {
      canAddDiscount,
      canChangeDiscount,
      canDeleteDiscount,
      canViewNotes,
      data,
      nodeIconClass,
      onNodeClick,
      openQuantityModal,
      addQuantityDiscounts,
      deleteQuantityDiscounts,
      confirmAction,
      confirmContent,
      closeConfirm,
      runConfirmedAction,
      checkedBranchRoots,
      reloadDiscounts,
      isTransferOpen,
      chevronTransferClass,
      storeOpenedNodes,
      selectedNode,
      checkedNodes,
      checkedNodesValue,
      discountErrors,
      clearDiscountErrors,
      importErrors,
      updateDiscount,
      updateCheckedDiscounts,
      mActions,
      modalLoading,
      modalTitle,
      modalFromAssistant,
      modalChildren,
      modalErrors,
      closeModal,
      selectAll,
      sAll,
      changeCheckedValues,
      applyCalcValue,
      calcValue,
      calcValueErrors,
      saveDiscount,
      discountFile,
      changeFile,
      importFile,
      loading,
      saving,
      uploading,
      isValueOpen,
      isTreeOpen,
      chevronValueClass,
      chevronTreeClass,
    };
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.node-type-icon {
  margin-left: 5px;
  margin-right: 5px;
  color: #676a6c;
}

.saving-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.5);
}
</style>
